import { Button, Modal, Row, Tag } from "antd";
import PropTypes from "prop-types";
import React from 'react';


class CaseSelectionModal extends React.Component {
    render() {
        return (
            <Modal
                title="Select Case"
                visible={this.props.visible}
                // onOk={this.handleOk}
                footer={() => <></>}
                onCancel={this.props.handleCancel}
            >
                {this.props.cases.map(_ => {
                    return <Row>
                        <Button type="link" onClick={() => this.props.handleCaseClick(_)}>{_.mpa_approval?.action_detail?.id}</Button>
                        <label> {_.getProductName()}</label>
                        <Tag className="ml-10"> {_.getIn(["mpa_approval", "action_detail", "current_action_task", "this_stage", "stage_name"])}</Tag>
                    </Row>
                })}
            </Modal>
        )
    }
}

CaseSelectionModal.propTypes = {
    handleCancel: PropTypes.func,
    handleOk: PropTypes.func,
    visible: PropTypes.bool,
    cases : PropTypes.array,
    handleCaseClick: PropTypes.func
};

export default CaseSelectionModal;